import React from "react";

// "OnHuman" wordmark — matches the neon-blue style of /public/images/onhuman.png.
// Bold rounded sans-serif, deep blue fill, layered blue glow halo.
export default function OnHumanHRLogo({
  className = "h-10 w-auto",
  title = "OnHuman",
}) {
  return (
    <svg
      viewBox="0 0 280 80"
      className={className}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="ohhr-fill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#2563eb" />
          <stop offset="100%" stopColor="#1d4ed8" />
        </linearGradient>
        <filter id="ohhr-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="1" stdDeviation="1.2" floodColor="#000000" floodOpacity="0.45" />
        </filter>
      </defs>

      <text
        x="140"
        y="56"
        textAnchor="middle"
        fontFamily="'Inter','Segoe UI',system-ui,-apple-system,sans-serif"
        fontSize="52"
        fontWeight="900"
        letterSpacing="-1.6"
        fill="url(#ohhr-fill)"
        filter="url(#ohhr-shadow)"
      >
        OnHuman
      </text>
    </svg>
  );
}
